import { Auth } from 'aws-amplify';

import { initializeApp } from 'firebase/app';
import { getMessaging, register as registerMessaging, onRegistered } from 'firebase/messaging';
import { getInstallations, getId } from 'firebase/installations';
import { firebaseConfig } from './firebaseConfig';
import { getApiBaseUrl } from './util/util';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// Helper that registers the SW you want
const registerMessagingServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return null;

  return navigator.serviceWorker.register('/service-worker.js');
};

// Function to request permission and register for messaging (FID-based)
export const fetchToken = async (setTokenFound, userType) => {
  try {
    const registration = await registerMessagingServiceWorker();
    if (!registration) {
      console.error('Service workers not supported or registration failed');
      setTokenFound(false);
      return;
    }
    const unsubscribe = onRegistered(messaging, async () => {
      try {
        // Obtain the Firebase Installation ID (FID)
        const fid = await getId(getInstallations(app));
        console.log('Firebase Installation ID (FID):', fid);
        if (fid) {
          setTokenFound(true);
          console.log('Token found:', fid);
          await sendRegistrationToServer(fid, userType);
        } else {
          console.warn('No Installation ID available after registration.');
          setTokenFound(false);
        }
      } catch (err) {
        console.error('Failed handling registration event', err);
        setTokenFound(false);
      } finally {
        unsubscribe();
      }
    });

    await registerMessaging(messaging, {
      vapidKey:
        'BHAZIBuJ-Bpm3vs-a2Wv8apSPyUY3l3DqjCIE0mV_y94B4_qIHL0Nihc8LSZkcIFoG7jqlQn8CsZxTyB-8f7pwU',
      serviceWorkerRegistration: registration,
    });
  } catch (err) {
    console.error('An error occurred while registering for messaging.', err);
    setTokenFound(false);
  }
};

// Send the Installation ID (FID) to your backend
const sendRegistrationToServer = async (fid, userType) => {
  try {
    const session = await Auth.currentSession().catch((err) => {
      console.log(err);
      return null;
    });
    console.log('Current session:', session);
    let jwtToken = '';
    await Auth.currentSession()
      .then((data) => {
        jwtToken = data.idToken.jwtToken;
      })
      .catch((err) => console.log(err));
    const res = await fetch(
      `${getApiBaseUrl(userType)}/save_token?token=${encodeURIComponent(fid)}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: jwtToken,
        },
      }
    );

    if (res.ok) {
      console.log('Successfully saved installation (FID).');
    } else {
      console.log('Error saving installation on server:', res.status, res.statusText);
    }
  } catch (err) {
    console.error('Error sending installation to server:', err);
  }
};
